/**
 * @file   src\mobile\components\Messages\MessagesLoadingSkeleton.js
 * @brief  This file is responsible for messages view in mobile.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { db } from "../../../firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import {
  capitalizeFirstString,
  getFileType,
  getInitials,
  getUserType,
  loggedInUser,
  removeDecimalZeros,
  setBodyBackgroundWhite,
  thousandSeperatedValue,
  truncate,
} from "../../../helpers/common";
import { IS_LAND, MAX_FILE_SIZE, MIN_HEIGHT, MIN_WIDHT, supportedImageFormatsMsgSection, USER_TYPE_AGENT } from "../../../constants/common";
import ProfPlaceholder from "../../../images/profile-placeholder.svg";
import ThumbCloseBtn from "../../../images/thumbnail-close-icon.svg";
import moment from "moment";
import {
  addMessage,
  updateIntroduction,
  updateIntroductionWithOutCreatedDate,
} from "../../../helpers/message";
import ClockIcon from "../../../images/clock-icon.svg";
import {
  saveChatEmail,
  updateIntroReplyStatus,
} from "../../../services/messagesService";
import {
  deleteSingleFile,
  getPreSignedUrl,
} from "../../../services/fileUploadService";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { CircularProgressbar } from "react-circular-progressbar";
import FileTypeIcn from "../../../images/file-type-icon.svg";
import ChangingProgressProvider from "../../../components/Messages/ChangingProgressProvider";
import MessageViewTopDropdown from "./MessageViewTopDropdown";
import ReasonNotAFitModal from "../ReceiveIntroduction/ReasonNotAFitModal";
import NotAFitModal from "../ReceiveIntroduction/NotAFitModal";
import BedSmallIcn from "../../images/bed-small-icn.svg";
import ReportUserModal from "../ReceiveIntroduction/ReportUserModal";
import { updateIntroNotFit } from "../../../services/introductionService";
import BathIcon from "../../images/bath-small-icn.svg";
import SqftIcon from "../../images/sqft-small-icn.svg";
import NeedAnAgentModal from "../../../components/Onboarding/NeedAnAgentModal";
import {
  INTRODUCTION_DETAILS,
  VIEW_CLIENT_WANTAD_DETAILS,
} from "../../../constants/onBoarding";

const MessagesView = (props) => {
  const selectedId = props.selectedId;
  const userId = props.userId;
  const selectedData = props.selectedData;
  const [messages, setMessages] = useState("");
  const [updatedMessages, setUpadtedMessages] = useState("");
  const [userData, setUserData] = useState("");
  const [message, SetMessage] = useState("");
  const [defaultMessage, SetDefaultMessage] = useState(false);
  const [wantAduser, SetWantAdUser] = useState(false);
  const userDetails = loggedInUser();
  const [isUploading, setIsUploading] = useState(false);
  const [preview, setPreview] = useState([]);
  const [uploadedImage, setUploadedImage] = useState([]);
  const supportedImageFormats = supportedImageFormatsMsgSection;
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const baseFolderPath = "/Chat";
  const [userDeleted, setUserDeleted] = useState(false);
  const [loginedUserDeleted, setLoginedUserDeleted] = useState(false);
  const userType = getUserType();
  const [showNotAFitModal, setShowNotAFitModal] = useState(false);
  const NotAFitModalClose = () => setShowNotAFitModal(false);
  const NotAFitModalShow = () => setShowNotAFitModal(true);
  const [showMarkFitConfirmModal, setMarkFitConfirmModal] = useState(false);
  const markFitConfirmModalClose = () => setMarkFitConfirmModal(false);
  const [showNotFirReasnPopup, setNotFitReasonPopup] = useState(false);
  const markFitReasonModalClose = () => setNotFitReasonPopup(false);

  const [showReportUserModal, setReportUserModal] = useState(false);
  const reportUserModalClose = () => setReportUserModal(false);
  const reportUserModalShow = () => setReportUserModal(true);

  const [showNeedAnAgentModal, setShowNeedAnAgemtModal] = useState(false);
  const needAnAgentModalOpen = () => {
    setShowNeedAnAgemtModal(true);
  };
  const needAnAgentModalClose = () => {
    setShowNeedAnAgemtModal(false);
  };

  const updateToNotFit = async (reqPayload, isSkip) => {
    if (reqPayload) {
      await updateIntroNotFit(reqPayload)
        .then(async (response) => {
          if (response.errorCode === 0) {
            let data = {
              isdeleted: true,
            };

            let updateresponse = await updateIntroduction(
              reqPayload?.IntroductionId,
              data
            );
            props.setUIKey("");
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const handleNotFitConfirm = () => {
    setNotFitReasonPopup(true);
  };

  const handleWantAdDetails = () => {
    props.setUIKey(VIEW_CLIENT_WANTAD_DETAILS);
  };

  useEffect(() => {
    if (selectedId) {
      const q = query(
        collection(db, "Chat", selectedId.toString(), "message"),
        orderBy("createdAt", "asc")
      );
      const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
        const fetchedMessages = [];
        QuerySnapshot.forEach((doc) => {
          fetchedMessages.push({ ...doc.data(), id: doc.id });
        });
        setMessages(fetchedMessages);
      });
      return () => unsubscribe;
    } else {
      setMessages([]);
    }
  }, [selectedId]);

  const updateReadStatus = async (data) => {
    let updateresponse = await updateIntroductionWithOutCreatedDate(
      selectedData?.introductionId,
      data
    );
  };

  useEffect(() => {
    if (selectedData) {
      setUserDeleted(false);
      setLoginedUserDeleted(false);
      props.userDeletedUpdate(false);

      let createdUser = "";
      if (selectedData?.wantAdCreatedId == userId) {
        let data = {
          isWantAdOwnerHasUnreadMessage: false,
        };
        updateReadStatus(data);

        if (selectedData?.isUserdeletedStatus == 2) {
          setUserDeleted(true);
          props.userDeletedUpdate(true);
        } else if (selectedData?.isUserdeletedStatus == 1) {
          setLoginedUserDeleted(true);
          props.userDeletedUpdate(true);
        }
        if (selectedData?.wantAdClientName) {
          createdUser = selectedData?.inventoryClientName;
        } else {
          createdUser = selectedData?.invetroyUserName + "'s invetory";
        }
        let { initials, backgroundColor } = getInitials(
          selectedData?.invetroyUserName + " " + selectedData?.invetroyUserName
        );
        setUserData({
          initials: initials,
          backgroundColor: backgroundColor,
          name: selectedData?.invetroyUserName,
          createdUser: createdUser,
          type: 1,
          agentId: selectedData?.inventroyCreatedId,
          photo: selectedData?.inventoryCreatedUserImage,
          company: selectedData?.inventoryCreatedUserCompany,
          location: selectedData?.inventoryCreatedUserLocation,
          isAgent: selectedData?.inventoryCreatedUserUserType
            ? selectedData?.inventoryCreatedUserUserType == "Customer"
              ? 0
              : 1
            : 0,
          clientName: null,
          clientId: null,
          userId: selectedData?.wantAdCreatedId,
          wantAdDetailsAdType: selectedData?.wantAdDetailsAdType,
        });
      } else if (selectedData?.inventroyCreatedId == userId) {
        let data = {
          isInventoryOwnerHasUnreadMessage: false,
        };
        updateReadStatus(data);

        if (selectedData?.isUserdeletedStatus == 1) {
          setUserDeleted(true);
          props.userDeletedUpdate(true);
        } else if (selectedData?.isUserdeletedStatus == 2) {
          setLoginedUserDeleted(true);
          props.userDeletedUpdate(true);
        }
        if (selectedData?.wantAdClientName) {
          createdUser = selectedData?.wantAdClientName;
        } else {
          createdUser = selectedData?.wantAdCreatedUserFirstName + "'s want ad";
        }

        let { initials, backgroundColor } = getInitials(
          selectedData?.wantAdCreatedUserFirstName +
          " " +
          selectedData?.wantAdCreatedUserLastName
        );
        setUserData({
          initials: initials,
          backgroundColor: backgroundColor,
          name: selectedData?.wantAdCreatedUserFirstName,
          createdUser: createdUser,
          type: 2,
          agentId: selectedData?.wantAdCreatedId,
          photo: selectedData?.wantAdCreatedUserImage,
          company: selectedData?.wantAdCreatedUserCompany,
          location: selectedData?.wantAdCreatedUserLocation,
          isAgent: selectedData?.wantAdCreatedUserType
            ? selectedData?.wantAdCreatedUserType == "Customer"
              ? 0
              : 1
            : 0,
          clientName: selectedData?.wantAdClientName,
          clientId: selectedData?.wantAdClientId,
          userId: selectedData?.inventroyCreatedId,
          wantAdDetailsAdType: selectedData?.wantAdDetailsAdType,
        });
      }
    }
  }, [selectedData]);

  useEffect(() => {
    if (messages) {
      let newFilterdData = [];
      messages.forEach((item) => {
        newFilterdData.push(item);
      });

      const formatedMessages = generateItems(newFilterdData);
      setUpadtedMessages(formatedMessages);
      SetMessage("");
      if (selectedData?.wantAdCreatedId == userId) {
        SetWantAdUser(true);
      } else {
        SetWantAdUser(false);
      }

      if (updatedMessages.length > 2) {
        SetDefaultMessage(true);
      } else {
        wantAduser ? SetDefaultMessage(false) : SetDefaultMessage(true);
      }
    } else {
      setUpadtedMessages([]);
    }
  }, [messages]);

  useEffect(() => {
    setBodyBackgroundWhite();
  }, []);

  function generateItems(messages) {
    const days = groupedDays(messages);
    const sortedDays = Object.keys(days).sort(
      (x, y) => moment(x, "YYYY-MM-DD").unix() - moment(y, "YYYY-MM-DD").unix()
    );

    const items = sortedDays.reduce((acc, date) => {
      const sortedMessages = days[date].sort(
        (x, y) => new Date(y.createdAt) - new Date(x.createdAt)
      );
      let showTime = false;
      let createdDateTime = "";
      let same = moment(new Date(), "DD-MM-YYYY").isSame(
        moment(new Date(date), "DD-MM-YYYY"),
        "day"
      );
      if (same && sortedMessages.length == 1) {
        showTime = true;
        createdDateTime = sortedMessages[0].createdAt;
      }

      if (date != "Invalid date") {
        return acc.concat([
          {
            type: "day",
            date,
            id: date,
            showTime: showTime,
            createdDateTime: createdDateTime,
          },
          ...sortedMessages,
        ]);
      }
      return acc.concat(...sortedMessages);
    }, []);
    return items;
  }

  const groupedDays = (messages) => {
    return messages.reduce((acc, el, i) => {
      const messageDay = moment(
        new Date(el.createdAt?.toDate()).toUTCString()
      ).format("YYYY-MM-DD");
      if (acc[messageDay]) {
        return { ...acc, [messageDay]: acc[messageDay].concat([el]) };
      }
      return { ...acc, [messageDay]: [el] };
    }, {});
  };

  function RenderItem({ item, index }) {
    if (
      item.type &&
      item.type === "day" &&
      (item?.createdDateTime || item.date)
    ) {
      return (
        <div className="wantad-messages-time mt-4">
          {item.showTime == true
            ? item?.createdDateTime &&
            "Today - " +
            moment(
              new Date(item?.createdDateTime?.toDate()).toUTCString()
            ).format("hh:mma")
            : item.date && moment(new Date(item.date)).format("MMM Do, YYYY")}
        </div>
      );
    }
    return (
      <>
        {!wantAduser && index == 1 && (
          // &&
          // (selectedData?.isrepiled == false)
          <div className="right-messages-box wantad-messages-box mb-2">
            <div className="add-your-property-mob">
              <div className="message-property-img-mob">
                <img src={selectedData?.inventoryPhoto} alt="" />
              </div>
              <div className="add-property-details-mob align-items-center">
                <div className="title d-flex align-items-center">
                  <h3>{selectedData?.inventoryLocation}</h3>
                </div>

                <ul className="want-ad-btm-list mb-0">
                  {selectedData?.IntroDetailsBedRoom && (
                    <>
                      <li>
                        <span className="list-txt-btm">
                          {removeDecimalZeros(
                            selectedData?.IntroDetailsBedRoom
                          )}
                        </span>
                        <span className="list-icns-btm">
                          <img src={BedSmallIcn} alt="" />
                        </span>
                      </li>
                    </>
                  )}
                  {selectedData?.IntroDetailsBathRoom && (
                    <>
                      <li className="sep-v-line">|</li>
                      <li>
                        <span className="list-txt-btm">
                          {removeDecimalZeros(
                            selectedData?.IntroDetailsBathRoom
                          )}
                        </span>
                        <span className="list-icns-btm">
                          <img src={BathIcon} alt="" />
                        </span>
                      </li>
                    </>
                  )}

                  {selectedData?.IntroDetailsSqft && (
                    <>
                      <li className="sep-v-line">|</li>
                      <li>
                        <span className="list-txt-btm">
                          {selectedData?.IntroDetailsSqft}
                        </span>
                        <span className="list-icns-btm">
                          <img src={SqftIcon} alt="" />
                        </span>
                      </li>
                    </>
                  )}
                </ul>
                {selectedData?.IntroDetailsAskingPrice && (
                  <span className="list-txt-btm me-0">
                    $
                    {thousandSeperatedValue(
                      selectedData?.IntroDetailsAskingPrice
                    )}{" "}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

        {item?.image &&
          item?.image.map((data, index) => (
            <div
              className={
                userId == item.createdUserId
                  ? "wantad-messages-box right-messages-box"
                  : "wantad-messages-box left-messages-box"
              }
            >
              {userId != item.createdUserId && (
                <div className="wantad-messages-img">
                  <img src={ProfPlaceholder} alt="" />
                </div>
              )}
              {data.type && data.type == "image" ? (
                <div className="msg-attached-img">
                  <img src={data?.preview} alt="" />
                </div>
              ) : (
                <a
                  href={data.preview}
                  download={data.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="file-type-outerwrap">
                    <div className="file-type-wrap">
                      <div className="file-type-icon">
                        <img src={FileTypeIcn} alt="" />
                      </div>
                      <div className="file-type-info">
                        <h2>{data.name}</h2>
                        <h6>{data.size}</h6>
                      </div>
                    </div>
                  </div>
                </a>
              )}
            </div>
          ))}

        {item?.text && (
          <div
            className={
              userId == item.createdUserId
                ? "wantad-messages-box right-messages-box"
                : "wantad-messages-box left-messages-box"
            }
          >
            {userId != item.createdUserId && (
              <div className="wantad-messages-img">
                <img src={ProfPlaceholder} alt="" />
              </div>
            )}

            <div className="wantad-messages-bubble">
              <div className="wantad-message-text">{item?.text}</div>
            </div>
          </div>
        )}

        {selectedData?.isrepiled == true && index == 1 && !wantAduser && (
          <p className="wantad-messages-accepted-para">
            {userData?.name} accepted your introduction at{" "}
            {moment(
              new Date(selectedData?.acceptedat?.toDate()).toUTCString()
            ).format("hh:mm A")}
          </p>
        )}
      </>
    );
  }

  const handleMessageChange = (e) => {
    let value = capitalizeFirstString(e.target.value);

    SetMessage(value);
  };

  const sendMessage = async () => {
    if ((message || uploadedImage.length > 0) && !isUploading) {
      let messageDoc = {
        createdUserId: _.get(userDetails, "userInfo.userId", null),
        uniqueId: selectedData?.introductionId,
        text: message,
        image: uploadedImage,
      };

      await addMessage(selectedData?.introductionId, messageDoc).then(
        async (response) => {
          if (response == 1) {
            SetMessage("");
          }
        }
      );

      let data = null;

      if (selectedData?.wantAdCreatedId == userId) {
        data = {
          lastestMessageSentUserId: _.get(userDetails, "userInfo.userId", null),
          latestMessage: message
            ? message
            : uploadedImage[uploadedImage.length - 1].name,
          isMessage: message ? 1 : 0,
          isrepiled: true,
          isInventoryOwnerHasUnreadMessage: true,
        };
      } else {
        data = {
          lastestMessageSentUserId: _.get(userDetails, "userInfo.userId", null),
          latestMessage: message
            ? message
            : uploadedImage[uploadedImage.length - 1].name,
          isMessage: message ? 1 : 0,
          isrepiled: true,
          isWantAdOwnerHasUnreadMessage: true,
        };
      }

      await updateIntroduction(selectedData?.introductionId, data).then(
        async (response) => {
          if (response == 1) {
            SetMessage("");
            setPreview([]);
            setUploadedImage([]);
          }
        }
      );

      await updateIntroReplyStatus(selectedData?.introductionId)
        .then(async (response) => {
          if (response.errorCode == 0) {
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
    let chatData = {
      userId:
        selectedData?.wantAdCreatedId == userId
          ? selectedData?.inventroyCreatedId
          : selectedData?.wantAdCreatedId,
      introId: selectedId,
      title:
        selectedData?.inventroyCreatedId == userId
          ? selectedData?.wantAdText + " in " + selectedData?.wantAdLocation
          : selectedData?.inventoryLocation,
      name:
        selectedData?.wantAdCreatedId == userId
          ? selectedData?.invetroyUserName
          : selectedData?.wantAdCreatedUserFirstName,
    };

    await saveChatEmail(chatData)
      .then(async (response) => {
        if (response.errorCode == 0) {
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const handler = (e) => {
    if (e.charCode == 13 || e.keyCode == 13) {
      sendMessage();
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [updatedMessages]);

  const scrollToBottom = () => {
    const bottom = document.documentElement.scrollHeight;
    window.scrollTo(0, bottom);
  };

  const handleImage = async (e) => {
    setIsUploading(true);
    const selectedFileType = getFileType(_.get(e.target.files[0], "name"));
    let fileSize = _.get(e.target.files[0], "size");
    const file = e.target.files[0];
    let isValid = false;
    let dataType = "";
    var fSExt = new Array("Bytes", "KB", "MB", "GB");
    let i = 0;
    while (fileSize > 900) {
      fileSize /= 1024;
      i++;
    }
    var exactSize = Math.round(fileSize * 100) / 100 + " " + fSExt[i];

    if (
      selectedFileType == "pdf" ||
      selectedFileType == "doc" ||
      selectedFileType == "docx"
    ) {
      if (
        _.includes(supportedImageFormats, selectedFileType) ||
        fileSize <= MAX_FILE_SIZE
      ) {
        isValid = true;
        dataType = "pdf/doc";

        setPreview([
          ...preview,
          {
            type: "pdf/doc",
            name: file.name,
            preview: "icon",
            uploading: false,
            size: exactSize,
          },
        ]);
      }
    } else {
      const image = new Image();
      image.src = URL.createObjectURL(file); // This is for getting image width and height

      if (
        _.includes(supportedImageFormats, selectedFileType) ||
        (fileSize <= MAX_FILE_SIZE &&
          image.width >= MIN_WIDHT &&
          image.height >= MIN_HEIGHT)
      ) {
        dataType = "image";
        isValid = true;
        setPreview([
          ...preview,
          {
            type: "image",
            name: file.name,
            preview: image.src,
            uploading: false,
            size: exactSize,
          },
        ]);
      }
    }

    if (isValid) {
      var mimeType = file.type;
      const imageId = preview.length !== 0 ? preview.length + 1 : 1;
      const fileName = Date.now() + "." + mimeType.split("/").pop();
      const imagePath =
        baseFolderPath +
        "/" +
        selectedData?.introductionId +
        "/" +
        imageId +
        "_" +
        fileName;

      const reqPayload = {
        key: imagePath,
      };

      await getPreSignedUrl(reqPayload)
        .then((response) => {
          if (response.errorCode === 0) {
            try {
              const headersValue = new Headers({ "Content-Type": file.type });
              fetch(response.result, {
                method: "PUT",
                headers: headersValue,
                body: file,
              })
                .then((response) => {
                  const status = _.get(response, "status", "");
                  const fileFullUrl = _.get(response, "url", "");
                  const fileS3Url = fileFullUrl
                    ? fileFullUrl.split("?")[0]
                    : "";

                  if (status === 200) {
                    if (fileS3Url) {
                      setUploadedImage((prevuploadedImage) => [
                        ...prevuploadedImage,
                        {
                          type: dataType,
                          name: file.name,
                          preview: fileS3Url,
                          size: exactSize,
                        },
                      ]);
                      setIsUploading(false);
                      setPreview((prevpreview) => [
                        ...prevpreview.filter((item) => item.name != file.name),
                        {
                          type: dataType,
                          name: file.name,
                          preview: fileS3Url,
                          uploading: true,
                          size: exactSize,
                        },
                      ]);
                    }
                  }
                })
                .catch((error) => {
                  setIsUploading(false);
                  toast.error(error);
                });
            } catch (error) {
              setIsUploading(false);
              toast.error(error);
            }
          } else {
            setIsUploading(false);
            toast.dismiss();
            toast.error(response.errorMessage);
          }
        })
        .catch((err) => {
          setIsUploading(false);
          toast.dismiss();
          toast.error(err);
        });
    } else {
      setIsUploading(false);
      alert(
        "Please upload a valid file. Check size(Max 1 Mb), for images dimensions(Minimum of 700 X 400) or file type(jpg, jpeg, png, heic, pdf, doc, docx)"
      );
    }
  };

  useEffect(() => {
    document.body.classList.add("need-agent-modal-fix");
  }, []);

  const removeImage = (index) => {
    preview.splice(index, 1);
    setPreview([...preview]);
    let deletedImage = uploadedImage.splice(index, 1);
    const deleteRequest = { key: deletedImage[0].preview };
    deleteImages(deleteRequest);
  };

  const deleteImages = async (deleteRequest) => {
    await deleteSingleFile(deleteRequest)
      .then((response) => {
        if (response.errorCode === 0) {
          return true;
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  function handleEmojiSelect(emoji) {
    SetMessage((prevInput) => prevInput + emoji);
  }

  const loadHeader = () => {
    return (
      <div className="top-three-comp-header w-100 flex-column top-three-comp-shadow">
        <div className="top-three-comp-header-inner w-100">
          <div>
            <a
              className="back-link-btn"
              href={void 0}
              onClick={() => {
                props.setUIKey(null);
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                  fill="#1B1C1E"
                />
              </svg>
            </a>
          </div>
          {userData?.isAgent == 0 ? (
            <div className="heading">
              {" "}
              {!wantAduser && selectedData?.isrepiled == false
                ? "Name Hidden Until Accepted"
                : userData?.name}
              {userDeleted && (
                <span className="property-action drop-pos-fix flex-shrink-0 modal-wrap-label-orange f-size-14 me-0">
                  {" "}
                  Deactivated
                </span>
              )}
            </div>
          ) : !wantAduser && selectedData?.isrepiled == false ? (
            <div className="heading"> Name Hidden Until Accepted </div>
          ) : (
            <>
              <div className="heading"> {userData?.name}</div>
              {userDeleted && (
                <span className="property-action drop-pos-fix flex-shrink-0 modal-wrap-label-orange f-size-14 me-0">
                  {" "}
                  Deactivated
                </span>
              )}
            </>
          )}

          <div className="social-btns-wrap">
            <MessageViewTopDropdown
              handleMarkNotFit={() => {
                NotAFitModalShow();
              }}
              handleWantAdDetails={() => {
                handleWantAdDetails();
              }}
              userData={userData}
              wantAdCreatedId={selectedData?.wantAdCreatedId}
              reportUserModalShow={() => {
                reportUserModalShow();
              }}
            />
          </div>
        </div>
        <div className="pt-2">
          <div className="add-your-property-mob">
            <div className="add-property-img-mob">
              {selectedData?.inventoryPhoto &&
                selectedData?.inventroyCreatedId != userId &&
                selectedData?.isrepiled == true ? (
                <img src={selectedData?.inventoryPhoto} alt="" />
              ) : selectedData?.wantAdDetailsLocation_Img ? (
                <img src={selectedData?.wantAdDetailsLocation_Img} alt="" />
              ) : selectedData?.wantAdPrprtyType == IS_LAND ||
                selectedData?.inventoryTypeId == IS_LAND ? (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.18895 1.24271C6.05566 1.23726 5.92411 1.27461 5.81356 1.34929C5.70301 1.42396 5.61925 1.53205 5.57453 1.65775L5.31493 2.3568C5.20688 2.34352 5.11145 2.29251 4.99999 2.29251C4.82056 2.29251 4.66295 2.36207 4.49299 2.39587L4.17886 1.70983C4.14595 1.63326 4.09806 1.56404 4.03801 1.50625C3.97796 1.44846 3.90695 1.40327 3.82917 1.37332C3.75139 1.34338 3.66841 1.32929 3.58511 1.33189C3.50181 1.33449 3.41986 1.35372 3.3441 1.38845C3.26834 1.42318 3.20029 1.47272 3.14396 1.53414C3.08762 1.59556 3.04414 1.66762 3.01606 1.7461C2.98799 1.82457 2.97589 1.90786 2.98048 1.99108C2.98507 2.0743 3.00626 2.15576 3.0428 2.23066L3.35367 2.90856C3.13374 3.08214 2.95633 3.28427 2.79865 3.51647L2.09227 3.25443C2.01491 3.2239 1.93222 3.20912 1.84907 3.21095C1.76592 3.21279 1.68397 3.2312 1.60802 3.26511C1.53207 3.29902 1.46366 3.34775 1.40678 3.40843C1.3499 3.46912 1.30571 3.54055 1.27679 3.61853C1.24787 3.69652 1.23481 3.77949 1.23836 3.86259C1.24192 3.94568 1.26202 4.02724 1.2975 4.10247C1.33297 4.17769 1.38311 4.24509 1.44496 4.30069C1.50681 4.3563 1.57914 4.399 1.6577 4.4263L2.35595 4.68509C2.3426 4.7934 2.29166 4.88911 2.29166 5.00085C2.29166 5.18039 2.3427 5.34505 2.37629 5.51517L1.70897 5.82116C1.63431 5.85535 1.56711 5.90391 1.51122 5.96407C1.45532 6.02423 1.41183 6.09481 1.38321 6.17179C1.3546 6.24876 1.34143 6.33062 1.34445 6.41268C1.34748 6.49474 1.36664 6.57541 1.40084 6.65006C1.43505 6.72472 1.48362 6.79191 1.54379 6.8478C1.60396 6.90368 1.67455 6.94716 1.75153 6.97576C1.82851 7.00436 1.91037 7.01751 1.99243 7.01447C2.0745 7.01143 2.15516 6.99226 2.22981 6.95804L2.87515 6.66263C3.06995 6.91126 3.30883 7.12181 3.57584 7.2917C2.72377 7.99961 2.20579 8.64769 1.95881 8.97301C1.95881 8.97329 1.95881 8.97356 1.95881 8.97383C1.76472 9.22962 1.66666 9.53939 1.66666 9.84948V14.3571V16.4592C1.66666 17.2571 2.32709 17.9175 3.12499 17.9175H16.875C17.6729 17.9175 18.3333 17.2571 18.3333 16.4592V6.10518C18.3333 5.39442 17.8098 4.77365 17.1029 4.66393C17.1026 4.66393 17.1023 4.66393 17.102 4.66393C16.3112 4.54217 15.1682 4.37585 12.7083 4.37585C10.7244 4.37585 9.07656 4.66628 7.701 5.09769C7.70217 5.06512 7.70832 5.03364 7.70832 5.00085C7.70832 4.82142 7.63877 4.66381 7.60497 4.49385L8.29019 4.17972C8.36676 4.14681 8.43598 4.09892 8.49377 4.03887C8.55156 3.97881 8.59675 3.90781 8.6267 3.83003C8.65664 3.75225 8.67073 3.66927 8.66813 3.58597C8.66553 3.50266 8.6463 3.42072 8.61157 3.34496C8.57684 3.2692 8.5273 3.20115 8.46588 3.14481C8.40446 3.08848 8.3324 3.04499 8.25392 3.01692C8.17545 2.98884 8.09216 2.97675 8.00894 2.98134C7.92572 2.98593 7.84427 3.00712 7.76936 3.04365L7.09227 3.35453C6.9186 3.13448 6.71672 2.95643 6.48436 2.7987L6.74641 2.09395C6.7825 2.00119 6.79593 1.90116 6.78556 1.80217C6.77519 1.70318 6.74134 1.60809 6.68681 1.52483C6.63228 1.44156 6.55865 1.37252 6.47206 1.32345C6.38547 1.27438 6.28841 1.2467 6.18895 1.24271ZM4.99999 3.54251C5.18228 3.54251 5.35177 3.58545 5.51187 3.64505H5.51268C5.53561 3.65291 5.55898 3.65944 5.58267 3.66458C5.90752 3.80465 6.16222 4.06212 6.31184 4.38154C6.32279 4.40816 6.33557 4.434 6.35009 4.45885C6.41651 4.62661 6.45832 4.80786 6.45832 5.00085C6.45832 5.15503 6.43471 5.30098 6.39159 5.43786C6.37636 5.48619 6.36707 5.5362 6.36392 5.58678C5.74115 5.85799 5.20012 6.15699 4.71923 6.46243C4.67035 6.43198 4.61749 6.40843 4.56216 6.39245C3.97235 6.20728 3.54166 5.66002 3.54166 5.00085C3.54166 4.81772 3.58407 4.64723 3.6442 4.48652C3.64447 4.48598 3.64474 4.48544 3.64501 4.4849C3.65248 4.46302 3.65873 4.44074 3.66373 4.41816C3.80428 4.09219 4.06296 3.83673 4.38394 3.68737C4.40855 3.67698 4.43247 3.66502 4.45556 3.65156C4.62394 3.58453 4.80611 3.54251 4.99999 3.54251ZM12.7083 5.62585C12.8967 5.62585 13.0255 5.6322 13.1974 5.63398C12.7478 5.95203 12.2453 6.34878 11.7033 6.86689C9.88333 8.60655 7.62801 11.61 5.73974 16.6675H3.12499C3.00205 16.6675 2.91666 16.5821 2.91666 16.4592V14.5549C6.36429 8.77278 11.7619 5.75524 11.7619 5.75524C11.8138 5.72686 11.8615 5.69124 11.9035 5.64945C12.1679 5.63874 12.429 5.62585 12.7083 5.62585ZM15.5542 5.73164C15.7511 5.74928 15.9274 5.76823 16.0905 5.78779C15.8208 6.13712 15.4819 6.63808 15.0838 7.37471C14.1788 9.04938 12.9903 11.9008 11.7562 16.6675H7.07763C8.87118 12.0328 10.9434 9.32269 12.5675 7.77022C14.2648 6.14785 15.3988 5.80407 15.3988 5.80407C15.4536 5.78718 15.5059 5.76281 15.5542 5.73164ZM9.17805 5.97253C7.49355 7.20861 5.02447 9.32084 2.91666 12.2787V9.84948C2.91666 9.80041 2.93149 9.75989 2.9549 9.72904H2.95409C3.51208 8.99403 5.14102 6.82004 9.17805 5.97253ZM17.0833 6.54544V16.4592C17.0833 16.5821 16.9979 16.6675 16.875 16.6675H13.0501C14.235 12.1687 15.3615 9.48947 16.1833 7.96878C16.5558 7.2794 16.8601 6.83395 17.0833 6.54544Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2.50781C11.4257 2.50781 10.8515 2.69464 10.377 3.06836H10.376L4.42969 7.75488C3.52791 8.46557 3 9.55149 3 10.7002V19.7441C3 20.7016 3.79252 21.4941 4.75 21.4941H19.25C20.2075 21.4941 21 20.7016 21 19.7441V10.7002C21 9.55149 20.4721 8.46557 19.5703 7.75488L19.5 7.69824V3.75C19.5 3.55109 19.421 3.36034 19.2803 3.21969C19.1397 3.07904 18.9489 3.00002 18.75 3H16.25C16.0511 3.00002 15.8603 3.07904 15.7197 3.21969C15.579 3.36034 15.5 3.55109 15.5 3.75V4.54688L13.623 3.06836C13.1485 2.69464 12.5743 2.50781 12 2.50781ZM12 4.00391C12.2449 4.00391 12.4899 4.08529 12.6953 4.24707L15.7861 6.68164C15.8967 6.76865 16.0296 6.82279 16.1695 6.83789C16.3094 6.85298 16.4507 6.82842 16.5773 6.767C16.7039 6.70558 16.8107 6.60979 16.8854 6.49056C16.9602 6.37134 16.9999 6.23349 17 6.09277V4.5H18V8.0625C18.0001 8.1759 18.0259 8.2878 18.0754 8.3898C18.125 8.4918 18.197 8.58123 18.2861 8.65137L18.6426 8.93262C19.1848 9.35993 19.5 10.0099 19.5 10.7002V19.7441C19.5 19.8917 19.3975 19.9941 19.25 19.9941H4.75C4.60248 19.9941 4.5 19.8917 4.5 19.7441V10.7002C4.5 10.0099 4.8152 9.35993 5.35742 8.93262L11.3047 4.24707C11.5101 4.08529 11.7551 4.00391 12 4.00391ZM7.25 11.9941C7.05109 11.9942 6.86034 12.0732 6.71969 12.2138C6.57904 12.3545 6.50002 12.5452 6.5 12.7441V16.7441C6.50002 16.943 6.57904 17.1338 6.71969 17.2744C6.86034 17.4151 7.05109 17.4941 7.25 17.4941H10.25C10.4489 17.4941 10.6397 17.4151 10.7803 17.2744C10.921 17.1338 11 16.943 11 16.7441V12.7441C11 12.5452 10.921 12.3545 10.7803 12.2138C10.6397 12.0732 10.4489 11.9942 10.25 11.9941H7.25ZM13.75 11.9941C13.5511 11.9942 13.3603 12.0732 13.2197 12.2138C13.079 12.3545 13 12.5452 13 12.7441V16.7441C13 16.943 13.079 17.1338 13.2197 17.2744C13.3603 17.4151 13.5511 17.4941 13.75 17.4941H16.75C16.9489 17.4941 17.1397 17.4151 17.2803 17.2744C17.421 17.1338 17.5 16.943 17.5 16.7441V12.7441C17.5 12.5452 17.421 12.3545 17.2803 12.2138C17.1397 12.0732 16.9489 11.9942 16.75 11.9941H13.75ZM8 13.4941H9.5V15.9941H8V13.4941ZM14.5 13.4941H16V15.9941H14.5V13.4941Z"
                    fill="#007EF5"
                  />
                </svg>
              )}
            </div>
            <div className="add-property-details-mob ">
              <div className="title d-flex align-items-center">
                <h3>
                  {selectedData?.inventroyCreatedId == userId
                    ? selectedData?.wantAdText +
                    " in " +
                    selectedData?.wantAdLocation
                    : selectedData?.inventoryLocation}
                </h3>
              </div>

              {selectedData?.inventroyCreatedId == userId && (
                <ul className="want-ad-btm-list mb-0">
                  {selectedData?.wantAdDetailsRadius && (
                    <>
                      <li>
                        <span className="list-txt-btm me-0">
                          {selectedData?.wantAdDetailsRadius} mi from{" "}
                          {selectedData?.wantAdDetailsLocation}{" "}
                        </span>
                      </li>
                    </>
                  )}
                  {selectedData?.wantAdDetailsBedrooms && (
                    <>
                      <li className="sep-v-line">|</li>
                      <li>
                        <span className="list-txt-btm">
                          {selectedData?.wantAdDetailsBedrooms == 99
                            ? "Any"
                            : selectedData?.wantAdDetailsBedrooms + "+"}
                        </span>
                        <span className="list-icns-btm">
                          <img src={BedSmallIcn} alt="" />
                        </span>
                      </li>
                    </>
                  )}
                  {selectedData?.wantAdDetailsBathrooms && (
                    <>
                      {" "}
                      <li className="sep-v-line">|</li>
                      <li>
                        <span className="list-txt-btm">
                          {selectedData?.wantAdDetailsBathrooms == 99
                            ? "Any"
                            : selectedData?.wantAdDetailsBathrooms + "+"}
                        </span>
                        <span className="list-icns-btm">
                          <img src={BathIcon} alt="" />
                        </span>
                      </li>
                    </>
                  )}
                </ul>
              )}
            </div>
            <span
              className="right-arrow-mob"
              role="button"
              onClick={() => {
                selectedData?.wantAdCreatedId == userId
                  ? props.setUIKey(INTRODUCTION_DETAILS)
                  : props.setUIKey(VIEW_CLIENT_WANTAD_DETAILS);
              }}
              onKeyDown={() => {
                selectedData?.wantAdCreatedId == userId
                  ? props.setUIKey(INTRODUCTION_DETAILS)
                  : props.setUIKey(VIEW_CLIENT_WANTAD_DETAILS);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.46967 3.96967C8.76256 3.67678 9.23744 3.67678 9.53033 3.96967L17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L9.53033 20.0303C9.23744 20.3232 8.76256 20.3232 8.46967 20.0303C8.17678 19.7374 8.17678 19.2626 8.46967 18.9697L15.4393 12L8.46967 5.03033C8.17678 4.73744 8.17678 4.26256 8.46967 3.96967Z"
                  fill="#1B1C1E"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="gitcha-main-wrapper pb-0 bg-white h-100">
        <div className="content-wrapper content-wrapper-h-100-percent">
          <div className="inner-layout-header-new bg-white ">
            {loadHeader()}
          </div>
          <div className="home-layout-content position-relative">
            <div className="messageWraper topPadding pl-16 pr-16 min-h-100 bg-white d-flex flex-column justify-content-end pb-84">
              {!userData?.isAgent &&
                userType != USER_TYPE_AGENT &&
                userData?.wantAdDetailsAdType === 1 && (
                  <button
                    className="btn btn-primary align-self-center need-agent-button mt-3"
                    onClick={needAnAgentModalOpen}
                  >
                    Need An Agent?
                  </button>
                )}
              {updatedMessages &&
                updatedMessages.map((msg, index) => (
                  <RenderItem item={msg} index={index} />
                ))}

              {!wantAduser && selectedData?.isrepiled == false && (
                <div className="wantad-notif-box">
                  <div className="wantad-notif-bubble ms-0 me-0">
                    <div className="msg-time-icon">
                      <img src={ClockIcon} alt="" />
                    </div>
                    <div className="msg-text-wrap">
                      <h6>They have 72 hours to reply</h6>
                      <p>
                        Test got your introduction and is reviewing it now. If
                        he doesn’t reply in this time the introduction will
                        expire.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="inner-layout-footer-new inner-layout-footer-topfix ">
          <div className="wantad-messages-bottom ">
            <div className="emojipicker-wrap">
              {showEmojiPicker && (
                <Picker
                  data={data}
                  onClickOutside={() => {
                    setShowEmojiPicker(!showEmojiPicker);
                  }}
                  emojiButtonColors={["rgba(102, 51, 153, .2)"]}
                  onEmojiSelect={(e) => {
                    handleEmojiSelect(e.native);
                  }}
                  navPosition="bottom"
                  previewPosition="none"
                  skinTonePosition="none"
                />
              )}
            </div>

            <div className="message-attach-wrap">
              <button
                className="btn"
                disabled={
                  (!wantAduser && selectedData?.isrepiled == false) ||
                    selectedData?.isUserdeletedStatus > 0 ||
                    isUploading
                    ? true
                    : false
                }
              >
                <input
                  type="file"
                  name="add-attachment"
                  id="add-attachment"
                  onChange={(e) => {
                    handleImage(e);
                  }}
                />
              </button>
            </div>
            <div className="messages-input-wrap">
              {preview.length > 0 && (
                <div className="msg-upload-thumbnail-wrap">
                  {preview.map((data, index) => (
                    <>
                      {!data.uploading ? (
                        data.type == "image" ? (
                          <div className="msg-upload-thumbnail">
                            <div
                              className="loading-circle-new"
                              style={{ width: 20, height: 20 }}
                            >
                              <ChangingProgressProvider
                                values={[0, 10, 20, 40, 60, 80, 100]}
                              >
                                {(percentage) => (
                                  <CircularProgressbar value={percentage} />
                                )}
                              </ChangingProgressProvider>
                            </div>
                            <img className="thumb-img" src={data.preview} alt="" />
                          </div>
                        ) : (
                          <div className="file-type-outer">
                            <div className="file-type-thumbnail d-flex justify-content-center align-items-center">
                              <div
                                className="loading-circle-new"
                                style={{ width: 20, height: 20 }}
                              >
                                <ChangingProgressProvider
                                  values={[0, 10, 20, 40, 60, 80, 100]}
                                >
                                  {(percentage) => (
                                    <CircularProgressbar value={percentage} />
                                  )}
                                </ChangingProgressProvider>
                              </div>
                              <div className="file-type-icon">
                                <img src={FileTypeIcn} alt="" />
                              </div>
                            </div>
                            <div className="file-name-info" title={data.name}>
                              {truncate(data.name, 5)}
                            </div>
                          </div>
                        )
                      ) : data.type == "image" ? (
                        <div className="msg-upload-thumbnail">
                          <div className="loading-overlay">
                            <button
                              className="thumb-close-btn"
                              onClick={() => {
                                removeImage(index);
                              }}
                            >
                              <img src={ThumbCloseBtn} alt="" />
                            </button>
                            <img className="thumb-img" src={data.preview} alt="" />
                          </div>
                        </div>
                      ) : (
                        <div className="file-type-outer">
                          <div className="file-type-thumbnail d-flex justify-content-center align-items-center">
                            <div className="loading-overlay d-flex align-items-center justify-content-center">
                              <button
                                className="thumb-close-btn"
                                onClick={() => {
                                  removeImage(index);
                                }}
                              >
                                <img src={ThumbCloseBtn} alt="" />
                              </button>

                              <div className="file-type-icon">
                                <img src={FileTypeIcn} alt="" />
                              </div>
                            </div>
                          </div>
                          <div className="file-name-info" title={data.name}>
                            {truncate(data.name, 5)}
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              )}

              <input
                type="text"
                className="form-control wantad-message-field"
                value={message}
                placeholder="Aa"
                onChange={(e) => {
                  handleMessageChange(e);
                }}
                onKeyPress={(e) => handler(e)}
                disabled={
                  (!wantAduser && selectedData?.isrepiled == false) ||
                    selectedData?.isUserdeletedStatus > 0
                    ? true
                    : false
                }
                maxLength={2000}
              />

              <button
                className="btn emoji-picker-icon"
                disabled={
                  (!wantAduser && selectedData?.isrepiled == false) ||
                    selectedData?.isUserdeletedStatus > 0
                    ? true
                    : false
                }
                onClick={(e) => {
                  e.stopPropagation();
                  setShowEmojiPicker(!showEmojiPicker);
                }}
              >
                emoji
              </button>
            </div>
            <button
              className="btn message-send-btn"
              disabled={
                (!wantAduser && selectedData?.isrepiled == false) ||
                  selectedData?.isUserdeletedStatus > 0 ||
                  isUploading
                  ? true
                  : false
              }
              onClick={() => {
                sendMessage();
              }}
            >
              Send
            </button>
          </div>
        </div>
      </div>

      <NotAFitModal
        show={showNotAFitModal}
        onHide={NotAFitModalClose}
        titleText="Are you sure you want to mark this introduction as not fit?"
        description="This action will end the introduction and associated conversation. Once you delete this it cannot be undone."
        buttonTitle="Confirm & Delete"
        updateToNotFit={updateToNotFit}
        introductionId={selectedData?.introductionId}
        showNotFirReasnPopup={showNotFirReasnPopup}
        handleNotFitConfirm={handleNotFitConfirm}
        markFitReasonModalClose={markFitReasonModalClose}
        name={userData?.name}
      />
      <ReasonNotAFitModal
        show={showMarkFitConfirmModal}
        onHide={markFitConfirmModalClose}
      />

      <ReportUserModal
        show={showReportUserModal}
        onHide={reportUserModalClose}
        IntroductionId={selectedData?.introductionId}
        inventoryDetails={""}
        isFromMessage={true}
        reportedUserId={userData.userId}
      />
      <NeedAnAgentModal
        show={showNeedAnAgentModal}
        onHide={needAnAgentModalClose}
      />
    </>
  );
};

export default MessagesView;
